var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "load-vals" },
    [
      _c(
        "form-group",
        {
          attrs: {
            name: _vm.capacityDefinition.type,
            label: _vm.capacityLabel,
          },
        },
        [
          _c("md-input", {
            model: {
              value: _vm.capacityValue,
              callback: function ($$v) {
                _vm.capacityValue = $$v
              },
              expression: "capacityValue",
            },
          }),
          _vm._v(
            "\n        " + _vm._s(_vm.capacityDefinition.symbol) + "\n    "
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }